import { useEffect, useMemo, useState } from 'react'
import { accentPalettes, defaultAccentId, getAccentPalette } from '../config/colorTokens'
import AccentContext from './accentContext'

const STORAGE_KEY = 'preferred-accent'

const getInitialAccent = () => {
	if (typeof window === 'undefined') return defaultAccentId

	const storedAccent = window.localStorage.getItem(STORAGE_KEY)
	return accentPalettes.some((palette) => palette.id === storedAccent) ? storedAccent : defaultAccentId
}

const applyAccentVariables = (palette) => {
	const root = document.documentElement

	root.style.setProperty('--site-accent', palette.accent)
	root.style.setProperty('--site-accent-mid', palette.accentMid)
	root.style.setProperty('--site-accent-end', palette.accentEnd)
	root.style.setProperty('--site-accent-glow', palette.accentGlow)
	root.style.setProperty('--site-accent-soft', palette.accentSoft)
	root.style.setProperty('--site-accent-wash', palette.accentWash)
}

const AccentState = ({ children }) => {
	const [accentId, setAccentId] = useState(getInitialAccent)
	const accentPalette = useMemo(() => getAccentPalette(accentId), [accentId])

	useEffect(() => {
		applyAccentVariables(accentPalette)
		window.localStorage.setItem(STORAGE_KEY, accentId)
	}, [accentId, accentPalette])

	return (
		<AccentContext.Provider value={{ accentId, setAccentId, accentPalette, accentPalettes }}>
			{children}
		</AccentContext.Provider>
	)
}

export default AccentState
